module.exports = __webpack_public_path__ + "static/media/icon-chabad-bor.dfeac362.svg";